import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import store from '@/store'
import md5 from 'md5';
import jsCookie from 'js-cookie';
import {
  Base64
} from 'js-base64';
import {
  setTitle,
  canTurnTo,
  axiosErr
} from '@/libs/utils';

Vue.use(Router)
const turnTo = (to, access, next) => {
    if (canTurnTo(to, access, routes)) next() // 有权限，可访问
    else next({
      replace: true,
      name: '401'
    }) // 无权限，重定向到401页面
  },
  router = new Router({
    // mode: "history",
    base: __dirname,
    routes
  })
let exclude = routes.filter(item => !item.children || item.name === 'index').map(item => {
  if (item.children) {
    let obj = [];
    for (const i of item.children) {
      obj.push(i.name)
    }
    return obj
  }
  return item.name
});
if ([].flat) {
  exclude = exclude.flat()
} else {
  let arr = [];
  for (const item of exclude) {
    if (Array.isArray(item)) {
      arr.push(...item)
    } else {
      arr.push(item)
    }
  }
  exclude = arr;
}

router.beforeEach((to, from, next) => {
  const account = sessionStorage.getItem('setAccountMessage') || "",
    toName = to.name,
    accord = exclude.includes(toName);
  if (!account && !accord) {
    //未登录且要跳转的页面不是登录页、注册页、首页、关于我们
    next({
      name: 'login'
    })
  } else if (!account && accord) {
    //未登录且登录的页面是登录页、注册页、首页、关于我们
    next()
  } else {
    if (store.state.admin.hasGetInfo) {
      //状态管理已缓存登录
      turnTo(to, store.state.admin.access, next)
    } else {
      //状态管理未缓存登录
      sessionStorage.removeItem("setAccountMessage")
      const name = localStorage.getItem('username') || "",
        pass = jsCookie.get(md5('pass')) || "",
        word = jsCookie.get(Base64.encode('word')) || "";
      if (name && pass && word && !accord) {
        //如果有缓存账号和密码且访问的页面不是登录页、注册页、首页、关于我们，则尝试登录账号
        store.dispatch('handleLogin', {
          username: name,
          password: Base64.decode(pass) + Base64.decode(word)
        }).then((res) => {
          if (res.code === 1000) {
            turnTo(to, store.state.admin.access, next)
          } else {
            next({
              name: 'login'
            })
          }
        }).catch((xml) => {
          const code = axiosErr(xml);
          next({
            name: code
          })
        });
      } else {
        next()
      }
    }

  }
})
// router.afterEach(to => {
//   setTitle(to, router.app)
  // window.scrollTo(0, 0)
// })
export default router



// WEBPACK FOOTER //
// ./src/router/index.js